/* Piercing Spot: Ear Stack Builder.
   Pick a placement on the ear, choose a piece from that placement's collection, build a look,
   then add the whole stack to the cart, save it as a link, or send it on WhatsApp. */
(function () {
  'use strict';

  var STORE_KEY = 'psStack:v1';
  var PAGE_SIZE = 12;

  function $(root, sel) { return root.querySelector(sel); }
  function $$(root, sel) { return Array.prototype.slice.call(root.querySelectorAll(sel)); }
  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  function toCents(price) { return Math.round(parseFloat(price) * 100) || 0; }
  function sized(src, w) {
    if (!src) return '';
    return src + (src.indexOf('?') > -1 ? '&' : '?') + 'width=' + w;
  }
  function titleCase(s) {
    return String(s || '').replace(/\S+/g, function (w) {
      if (/\d/.test(w) || (w.length > 1 && w === w.toUpperCase())) return w;
      return w.charAt(0).toUpperCase() + w.slice(1);
    });
  }

  function init(root) {
    if (root.dataset.psReady) return;
    root.dataset.psReady = '1';

    var cfgEl = $(root, '[data-ps-config]');
    var cfg = JSON.parse(cfgEl.textContent);
    var spots = cfg.spots;
    var cache = {};          // collection handle -> promise of products
    var state = {};          // spot key -> piece
    var active = -1;
    var shown = PAGE_SIZE;

    var ear = $(root, '[data-ps-ear]');
    var spotBtns = $$(root, '[data-ps-spot]');
    var chips = $$(root, '[data-ps-chip]');
    var grid = $(root, '[data-ps-grid]');
    var more = $(root, '[data-ps-more]');
    var panelTitle = $(root, '[data-ps-panel-title]');
    var panelDesc = $(root, '[data-ps-panel-desc]');
    var panelAll = $(root, '[data-ps-panel-all]');
    var list = $(root, '[data-ps-list]');
    var empty = $(root, '[data-ps-empty]');
    var totalRow = $(root, '[data-ps-totalrow]');
    var totalEl = $(root, '[data-ps-total]');
    var addBtn = $(root, '[data-ps-add]');
    var shareBtn = $(root, '[data-ps-share]');
    var waBtn = $(root, '[data-ps-wa]');
    var clearBtn = $(root, '[data-ps-clear]');
    var msg = $(root, '[data-ps-msg]');
    var bar = $(root, '[data-ps-bar]');
    var mobileBar = $(root, '[data-ps-mobilebar]');
    var mCount = $(root, '[data-ps-mcount]');
    var mTotal = $(root, '[data-ps-mtotal]');

    function money(cents) {
      var v = (cents / 100).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
      return (cfg.currency ? cfg.currency + ' ' : '') + v;
    }

    /* ---------- data ---------- */
    function loadCollection(handle) {
      if (!handle) return Promise.resolve([]);
      if (cache[handle]) return cache[handle];
      var base = cfg.root.replace(/\/$/, '') + '/collections/' + encodeURIComponent(handle) + '/products.json?limit=250';
      cache[handle] = Promise.all([1, 2].map(function (page) {
        return fetch(base + '&page=' + page, { headers: { Accept: 'application/json' } })
          .then(function (r) { return r.ok ? r.json() : { products: [] }; })
          .catch(function () { return { products: [] }; });
      })).then(function (pages) {
        var seen = {};
        var out = [];
        pages.forEach(function (p) {
          (p.products || []).forEach(function (prod) {
            if (seen[prod.id]) return;
            seen[prod.id] = 1;
            var variants = (prod.variants || []).filter(function (v) { return v.available !== false; });
            if (!variants.length) return;
            var image = prod.images && prod.images[0] ? prod.images[0].src : '';
            out.push({
              id: prod.id,
              handle: prod.handle,
              title: titleCase(prod.title),
              image: image,
              options: (prod.options || []).map(function (o) { return { name: o.name, values: o.values || [] }; }),
              variants: variants.map(function (v) {
                return {
                  id: v.id,
                  title: v.title === 'Default Title' ? '' : v.title,
                  opts: [v.option1, v.option2, v.option3].filter(function (x) { return x != null; }),
                  price: toCents(v.price),
                  image: v.featured_image && v.featured_image.src ? v.featured_image.src : image
                };
              })
            });
          });
        });
        return out;
      });
      return cache[handle];
    }

    /* ---------- selecting a placement ---------- */
    function select(index, scroll) {
      active = index;
      shown = PAGE_SIZE;
      var spot = spots[index];
      spotBtns.forEach(function (b, i) { b.classList.toggle('is-active', i === index); });
      chips.forEach(function (c, i) {
        c.setAttribute('aria-selected', i === index ? 'true' : 'false');
        if (i === index && c.scrollIntoView) c.scrollIntoView({ block: 'nearest', inline: 'center', behavior: 'smooth' });
      });
      panelTitle.textContent = spot.name;
      panelDesc.textContent = spot.desc || 'Choose a piece for your ' + spot.name.toLowerCase() + '.';
      if (spot.collectionUrl) { panelAll.href = spot.collectionUrl; panelAll.hidden = false; } else { panelAll.hidden = true; }
      grid.innerHTML = '<li class="psb-loading">Loading jewelry…</li>';
      more.hidden = true;
      loadCollection(spot.collection).then(function (products) {
        if (active !== index) return;
        renderGrid(products);
      });
      if (scroll && window.matchMedia('(max-width: 989px)').matches) {
        var panel = $(root, '[data-ps-panel]');
        if (panel && panel.scrollIntoView) panel.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    }

    function renderGrid(products) {
      var spot = spots[active];
      var current = state[spot.key];
      if (!products.length) {
        grid.innerHTML = '<li class="psb-loading">No pieces in stock for this placement right now.</li>';
        more.hidden = true;
        return;
      }
      if (current) {
        var idx = -1;
        for (var k = 0; k < products.length; k++) { if (products[k].id === current.productId) { idx = k; break; } }
        if (idx > 0) products = [products[idx]].concat(products.slice(0, idx), products.slice(idx + 1));
      }
      grid.innerHTML = products.slice(0, shown).map(function (p) {
        var picked = current && current.productId === p.id;
        var from = p.variants.reduce(function (m, v) { return Math.min(m, v.price); }, Infinity);
        var varies = p.variants.some(function (v) { return v.price !== from; });
        var multi = p.variants.length > 1;
        var cta = picked ? 'Change piece' : (multi ? 'Choose options' : 'Add to ear');
        return '<li class="psb-card' + (picked ? ' is-picked' : '') + '">' +
          '<button type="button" class="psb-card__btn" data-ps-pick="' + p.id + '" aria-label="' + esc((picked ? 'Selected: ' : 'Add to ' + spot.name + ': ') + p.title) + '">' +
            '<span class="psb-card__img">' + (p.image ? '<img src="' + esc(sized(p.image, 360)) + '" alt="" loading="lazy" width="180" height="180">' : '') +
              (picked ? '<span class="psb-card__badge">On your ear</span>' : '') + '</span>' +
            '<span class="psb-card__name">' + esc(p.title) + '</span>' +
            '<span class="psb-card__price">' + (varies ? 'From ' : '') + money(from) + '</span>' +
            '<span class="psb-card__cta">' + (picked ? '' : '<span aria-hidden="true">+</span>') + esc(cta) + '</span>' +
          '</button>' +
          (picked ? '<button type="button" class="psb-card__remove" data-ps-unpick>Remove from ear</button>' : '') +
          '<a class="psb-card__link" href="' + esc(cfg.root.replace(/\/$/, '') + '/products/' + p.handle) + '" target="_blank" rel="noopener">View details</a>' +
        '</li>';
      }).join('');
      more.hidden = products.length <= shown;
    }

    function findProduct(handle, productId) {
      return loadCollection(handle).then(function (products) {
        for (var i = 0; i < products.length; i++) if (products[i].id === productId) return products[i];
        return null;
      });
    }

    function place(spot, product, variant) {
      state[spot.key] = {
        productId: product.id,
        variantId: variant.id,
        title: product.title,
        option: variant.title,
        price: variant.price,
        image: variant.image || product.image,
        handle: product.handle
      };
      save();
      render();
      loadCollection(spot.collection).then(function (products) { if (spots[active] === spot) renderGrid(products); });
      var idx = spots.indexOf(spot);
      var btn = spotBtns[idx];
      if (btn) { btn.classList.remove('is-pop'); void btn.offsetWidth; btn.classList.add('is-pop'); }
    }

    grid.addEventListener('click', function (e) {
      var spot = spots[active];
      if (!spot) return;
      if (e.target.closest('[data-ps-unpick]')) {
        delete state[spot.key];
        save();
        render();
        loadCollection(spot.collection).then(renderGrid);
        return;
      }
      var pick = e.target.closest('[data-ps-pick]');
      if (!pick) return;
      var productId = parseInt(pick.getAttribute('data-ps-pick'), 10);
      findProduct(spot.collection, productId).then(function (p) {
        if (!p) return;
        if (p.variants.length === 1) { place(spot, p, p.variants[0]); return; }
        openModal(spot, p, pick);
      });
    });

    /* ---------- options sheet ---------- */
    var modal = $(root, '[data-ps-modal]');
    var mImg = $(root, '[data-ps-m-img]');
    var mWhere = $(root, '[data-ps-m-where]');
    var mTitle = $(root, '[data-ps-m-title]');
    var mPrice = $(root, '[data-ps-m-price]');
    var mLink = $(root, '[data-ps-m-link]');
    var mOptions = $(root, '[data-ps-m-options]');
    var mPlace = $(root, '[data-ps-m-place]');
    var mCart = $(root, '[data-ps-m-cart]');
    var mMsg = $(root, '[data-ps-m-msg]');
    var m = { spot: null, product: null, sel: [], opener: null };

    function matchVariant(p, sel) {
      return p.variants.filter(function (v) {
        return v.opts.every(function (o, i) { return o === sel[i]; });
      })[0] || null;
    }

    function openModal(spot, p, opener) {
      var cur = state[spot.key];
      var base = (cur && cur.productId === p.id && p.variants.filter(function (v) { return v.id === cur.variantId; })[0]) || p.variants[0];
      m.spot = spot; m.product = p; m.sel = base.opts.slice(); m.opener = opener || null;
      mMsg.textContent = '';
      renderModal();
      modal.hidden = false;
      document.documentElement.classList.add('psb-lock');
      var close = $(modal, '.psb-modal__close');
      if (close) close.focus();
    }

    function closeModal() {
      modal.hidden = true;
      document.documentElement.classList.remove('psb-lock');
      if (m.opener && document.body.contains(m.opener)) m.opener.focus();
    }

    function renderModal() {
      var p = m.product;
      var v = matchVariant(p, m.sel);
      var img = (v && v.image) || p.image;
      mImg.innerHTML = img ? '<img src="' + esc(sized(img, 400)) + '" alt="">' : '';
      mWhere.textContent = m.spot.name;
      mTitle.textContent = p.title;
      mPrice.textContent = v ? money(v.price) : 'Not available in this combination';
      mLink.href = cfg.root.replace(/\/$/, '') + '/products/' + p.handle + (v ? '?variant=' + v.id : '');
      mOptions.innerHTML = p.options.map(function (o, i) {
        var values = o.values.filter(function (val) { return p.variants.some(function (x) { return x.opts[i] === val; }); });
        if (!values.length) return '';
        return '<fieldset class="psb-opt"><legend>' + esc(o.name) + ': <b>' + esc(m.sel[i] || '') + '</b></legend><div class="psb-opt__vals">' +
          values.map(function (val) {
            var ok = p.variants.some(function (x) {
              return x.opts[i] === val && x.opts.every(function (y, j) { return j === i || y === m.sel[j]; });
            });
            return '<button type="button" class="psb-optval' + (m.sel[i] === val ? ' is-on' : '') + (ok ? '' : ' is-na') + '" data-i="' + i + '" data-v="' + esc(val) + '" aria-pressed="' + (m.sel[i] === val ? 'true' : 'false') + '">' + esc(val) + '</button>';
          }).join('') + '</div></fieldset>';
      }).join('');
      mPlace.disabled = !v;
      mCart.disabled = !v;
      var cur = state[m.spot.key];
      mPlace.textContent = (cur && cur.productId === p.id ? 'Update my ' : 'Place on my ') + m.spot.name.toLowerCase() + (v ? ' · ' + money(v.price) : '');
    }

    mOptions.addEventListener('click', function (e) {
      var b = e.target.closest('[data-v]');
      if (!b) return;
      var i = parseInt(b.getAttribute('data-i'), 10);
      var val = b.getAttribute('data-v');
      m.sel[i] = val;
      if (!matchVariant(m.product, m.sel)) {
        var alt = m.product.variants.filter(function (x) { return x.opts[i] === val; })[0];
        if (alt) m.sel = alt.opts.slice();
      }
      renderModal();
    });

    mPlace.addEventListener('click', function () {
      var v = matchVariant(m.product, m.sel);
      if (!v) return;
      place(m.spot, m.product, v);
      closeModal();
      if (window.matchMedia('(max-width: 989px)').matches && ear.scrollIntoView) ear.scrollIntoView({ behavior: 'smooth', block: 'center' });
    });

    mCart.addEventListener('click', function () {
      var v = matchVariant(m.product, m.sel);
      if (!v) return;
      mCart.disabled = true;
      addToCart([{ id: v.id, quantity: 1, properties: { Placement: m.spot.name } }], function (err) {
        mCart.disabled = false;
        if (err) { mMsg.textContent = err; return; }
        closeModal();
      });
    });

    $$(modal, '[data-ps-close]').forEach(function (b) { b.addEventListener('click', closeModal); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !modal.hidden) closeModal(); });

    more.addEventListener('click', function () {
      shown += PAGE_SIZE;
      loadCollection(spots[active].collection).then(renderGrid);
    });

    spotBtns.forEach(function (b) {
      b.addEventListener('click', function () { select(parseInt(b.getAttribute('data-ps-spot'), 10), true); });
    });
    chips.forEach(function (c) {
      c.addEventListener('click', function () { select(parseInt(c.getAttribute('data-ps-chip'), 10), false); });
    });

    /* ---------- stack summary ---------- */
    function pieces() {
      return spots.filter(function (s) { return state[s.key]; }).map(function (s) { return { spot: s, piece: state[s.key] }; });
    }

    function render() {
      var items = pieces();
      var total = items.reduce(function (sum, it) { return sum + it.piece.price; }, 0);

      spotBtns.forEach(function (b, i) {
        var piece = state[spots[i].key];
        b.classList.toggle('is-filled', !!piece);
        b.innerHTML = piece
          ? '<img src="' + esc(sized(piece.image, 120)) + '" alt="">'
          : '<span class="psb-spot__plus" aria-hidden="true">+</span>';
        b.setAttribute('aria-label', spots[i].name + (piece ? ': ' + piece.title : ''));
      });
      chips.forEach(function (c, i) { c.classList.toggle('is-filled', !!state[spots[i].key]); });
      var barOn = spots.some(function (s) { return s.bar && state[s.key]; });
      if (bar) bar.classList.toggle('is-on', barOn);

      list.innerHTML = items.map(function (it) {
        return '<li class="psb-row">' +
          '<span class="psb-row__img">' + (it.piece.image ? '<img src="' + esc(sized(it.piece.image, 120)) + '" alt="" loading="lazy">' : '') + '</span>' +
          '<span class="psb-row__info"><span class="psb-row__where">' + esc(it.spot.name) + '</span>' +
            '<span class="psb-row__name">' + esc(it.piece.title) + '</span>' +
            (it.piece.option ? '<span class="psb-row__opt">' + esc(it.piece.option) + '</span>' : '') + '</span>' +
          '<span class="psb-row__price">' + money(it.piece.price) + '</span>' +
          '<button type="button" class="psb-row__remove" data-ps-remove="' + esc(it.spot.key) + '" aria-label="Remove ' + esc(it.piece.title) + '">&times;</button>' +
        '</li>';
      }).join('');

      var has = items.length > 0;
      empty.hidden = has;
      totalRow.hidden = !has;
      clearBtn.hidden = !has;
      totalEl.textContent = money(total);
      addBtn.disabled = !has;
      addBtn.textContent = has ? 'Add ' + items.length + (items.length === 1 ? ' piece' : ' pieces') + ' to cart' : 'Add stack to cart';
      shareBtn.disabled = !has;
      waBtn.setAttribute('aria-disabled', has ? 'false' : 'true');
      waBtn.href = has ? waLink(items, total) : 'https://wa.me/' + cfg.wa;
      if (mobileBar) {
        mobileBar.hidden = !has;
        mCount.textContent = items.length + (items.length === 1 ? ' piece' : ' pieces');
        mTotal.textContent = money(total);
      }
    }

    list.addEventListener('click', function (e) {
      var r = e.target.closest('[data-ps-remove]');
      if (!r) return;
      delete state[r.getAttribute('data-ps-remove')];
      save();
      render();
      if (active > -1) loadCollection(spots[active].collection).then(renderGrid);
    });

    clearBtn.addEventListener('click', function () {
      state = {};
      save();
      render();
      if (active > -1) loadCollection(spots[active].collection).then(renderGrid);
    });

    /* ---------- save, share, WhatsApp ---------- */
    function shareUrl() {
      var parts = pieces().map(function (it) { return it.spot.key + ':' + it.piece.variantId; });
      var url = new URL(window.location.href);
      url.hash = '';
      url.searchParams.set('stack', parts.join(','));
      return url.toString();
    }

    function waLink(items, total) {
      var lines = ['Hi, I built this ear stack on your website:'];
      items.forEach(function (it) {
        lines.push('- ' + it.spot.name + ': ' + it.piece.title + (it.piece.option ? ' (' + it.piece.option + ')' : ''));
      });
      lines.push('Total: ' + money(total));
      lines.push(shareUrl());
      return 'https://wa.me/' + cfg.wa + '?text=' + encodeURIComponent(lines.join('\n'));
    }

    function save() {
      try { localStorage.setItem(STORE_KEY, JSON.stringify(state)); } catch (e) {}
      try {
        if (window.history && window.history.replaceState) {
          var url = new URL(window.location.href);
          if (pieces().length) url.searchParams.set('stack', pieces().map(function (it) { return it.spot.key + ':' + it.piece.variantId; }).join(','));
          else url.searchParams.delete('stack');
          window.history.replaceState(null, '', url.toString());
        }
      } catch (e) {}
    }

    shareBtn.addEventListener('click', function () {
      var url = shareUrl();
      var done = function () { msg.textContent = 'Link copied. Open it any time to see this stack again.'; };
      if (navigator.share && window.matchMedia('(max-width: 989px)').matches) {
        navigator.share({ title: 'My ear stack', url: url }).catch(function () {});
        return;
      }
      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(url).then(done, function () { window.prompt('Copy your stack link:', url); });
      } else {
        window.prompt('Copy your stack link:', url);
      }
    });

    /* keep sticky parts just under the site header, whatever its height */
    var headerEl = document.querySelector('sticky-header') || document.querySelector('.section-header') || document.querySelector('header');
    var topTick = false;
    function setTop() {
      topTick = false;
      var b = 0;
      if (headerEl) {
        var r = headerEl.getBoundingClientRect();
        b = r.bottom > 0 ? r.bottom : 0;
      }
      root.style.setProperty('--psb-top', Math.round(b) + 'px');
    }
    function queueTop() { if (!topTick) { topTick = true; window.requestAnimationFrame(setTop); } }
    window.addEventListener('scroll', queueTop, { passive: true });
    window.addEventListener('resize', queueTop);
    setTop();

    var mAdd = $(root, '[data-ps-madd]');
    if (mAdd) mAdd.addEventListener('click', function () { addBtn.click(); });

    waBtn.addEventListener('click', function (e) {
      if (waBtn.getAttribute('aria-disabled') === 'true') e.preventDefault();
    });

    /* ---------- add to cart ---------- */
    function addToCart(items, done) {
      var drawer = document.querySelector('cart-drawer');
      var payload = { items: items };
      if (drawer && drawer.getSectionsToRender) {
        payload.sections = drawer.getSectionsToRender().map(function (x) { return x.id; });
        payload.sections_url = window.location.pathname;
      }
      fetch(cfg.cartAdd + '.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify(payload)
      })
        .then(function (res) { return res.json().then(function (data) { return { ok: res.ok, data: data }; }); })
        .then(function (result) {
          if (!result.ok) { done(result.data.description || result.data.message || 'Something went wrong. Please try again.'); return; }
          if (drawer && drawer.renderContents && result.data.sections) {
            done(null);
            drawer.classList.remove('is-empty');
            drawer.renderContents(result.data);
            return;
          }
          window.location.href = cfg.cartUrl;
        })
        .catch(function () { done('Something went wrong. Please try again.'); });
    }

    addBtn.addEventListener('click', function () {
      var items = pieces().map(function (it) {
        return { id: it.piece.variantId, quantity: 1, properties: { Placement: it.spot.name } };
      });
      if (!items.length) return;
      addBtn.disabled = true;
      msg.textContent = '';
      addToCart(items, function (err) {
        if (err) msg.textContent = err;
        render();
      });
    });

    /* ---------- restore ---------- */
    function restoreFromParam(param) {
      var jobs = param.split(',').map(function (pair) {
        var bits = pair.split(':');
        var key = bits[0];
        var vid = parseInt(bits[1], 10);
        var spot = spots.filter(function (s) { return s.key === key; })[0];
        if (!spot || !vid) return Promise.resolve();
        return loadCollection(spot.collection).then(function (products) {
          for (var i = 0; i < products.length; i++) {
            for (var j = 0; j < products[i].variants.length; j++) {
              var v = products[i].variants[j];
              if (v.id === vid) {
                state[spot.key] = { productId: products[i].id, variantId: v.id, title: products[i].title, option: v.title, price: v.price, image: v.image || products[i].image, handle: products[i].handle };
                return;
              }
            }
          }
        });
      });
      return Promise.all(jobs);
    }

    var param = new URLSearchParams(window.location.search).get('stack');
    var ready;
    if (param) {
      ready = restoreFromParam(param);
    } else {
      try {
        var saved = JSON.parse(localStorage.getItem(STORE_KEY) || 'null');
        if (saved && typeof saved === 'object') {
          spots.forEach(function (s) { if (saved[s.key]) state[s.key] = saved[s.key]; });
        }
      } catch (e) {}
      ready = Promise.resolve();
    }
    ready.then(function () {
      render();
      var firstEmpty = 0;
      for (var i = 0; i < spots.length; i++) { if (!state[spots[i].key]) { firstEmpty = i; break; } }
      if (spots.length) select(firstEmpty, false);
    });

    document.addEventListener('shopify:block:select', function (event) {
      if (!root.contains(event.target)) return;
      var idx = event.target.getAttribute('data-ps-spot');
      if (idx !== null) select(parseInt(idx, 10), false);
    });
  }

  function boot() { $$(document, '[data-ps-stack]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();
